import ExtendedMap from '@/models/ExtendedMap'

import { CurriculumAnalysis } from './CurriculumAnalysis'

// 학생 단원별 분석 데이터
export class CurriculumAnalysisColl {
  conceptHashMap: ExtendedMap<CurriculumAnalysis['relationId'], CurriculumAnalysis>
  curriculumHashMap: ExtendedMap<CurriculumAnalysis['relationId'], CurriculumAnalysis>

  constructor(param: res.CurriculumAnalysis[]) {
    const curriculumArr = param.map((d) => new CurriculumAnalysis(d))
    this.conceptHashMap = ExtendedMap.fromArr(
      curriculumArr.filter(({ type }) => type === 'CONCEPT'),
      'relationId',
    )
    this.curriculumHashMap = ExtendedMap.fromArr(
      curriculumArr.filter(({ type }) => type === 'CURRICULUM'),
      'relationId',
    )
  }
}
